export default __webpack_public_path__ + "static/media/nba-bg.b2d610b7.jpg";